export default "__VITE_ASSET__DyBGzi8A__"